import {
  Email,
  EmailOutlined,
  Facebook,
  FacebookOutlined,
  Instagram,
  Reddit,
  Twitter,
  YouTube,
} from "@mui/icons-material";

import { ReactComponent as OpenSea } from "../assets/opensea-white.svg";
const {
  Box,
  Grid,
  Typography,
  FormControl,
  OutlinedInput,
  Button,
  Divider,
} = require("@mui/material");

const Footer = () => {
  return (
    <Box
      sx={{
        bgcolor: "#1868b7",
        mt: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid container spacing={1}>
        <Grid items sm={6}>
          <Box sx={{ padding: 4, color: "white" }}>
            <Typography variant='h5' fontWeight={"bold"}>
              Stay in the loop
            </Typography>
            <Typography py={2} variant='subtitle1' fontWeight={400}>
              Join our mailing list to stay in the loop with our newest feature
              releases, NFT drops, and tips and tricks for navigating OpenSea.
            </Typography>
            <Box sx={{ display: "flex" }}>
              <FormControl sx={{ width: "85%" }}>
                <OutlinedInput
                  placeholder='Your email address'
                  sx={{ borderRadius: "10px", bgcolor: "white" }}
                />
              </FormControl>
              <Button
                sx={{
                  width: "15%",
                  ml: 2,
                  borderRadius: "15px",
                  textTransform: "none",
                }}
                variant='contained'
              >
                Sign Up
              </Button>
            </Box>
          </Box>
        </Grid>
        <Grid items sm={6}>
          <Box sx={{ padding: 4, color: "white" }}>
            <Typography variant='h5' fontWeight={"bold"} mb={2}>
              Join the community
            </Typography>
            <Box sx={{ display: "flex" }}>
              <Button
                sx={{ py: 2, borderRadius: "10px", mx: 1 }}
                variant='contained'
              >
                <Twitter sx={{ color: "white" }} />
              </Button>
              <Button
                sx={{ py: 2, borderRadius: "10px", mx: 0.5 }}
                variant='contained'
              >
                <Instagram sx={{ color: "white" }} />
              </Button>
              <Button
                sx={{ py: 2, borderRadius: "10px", mx: 0.5 }}
                variant='contained'
              >
                <FacebookOutlined sx={{ color: "white" }} />
              </Button>
              <Button
                sx={{ py: 2, borderRadius: "10px", mx: 0.5 }}
                variant='contained'
              >
                <Reddit sx={{ color: "white" }} />
              </Button>
              <Button
                sx={{ py: 2, borderRadius: "10px", mx: 0.5 }}
                variant='contained'
              >
                <YouTube sx={{ color: "white" }} />
              </Button>
              <Button
                sx={{ py: 2, borderRadius: "10px", mx: 0.5 }}
                variant='contained'
              >
                <EmailOutlined sx={{ color: "white" }} />
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Divider
        sx={{
          color: "white",
          my: 3,
          px: 4,
          border: "1px solid white",
          width: "98%",
          opacity: 0.4,
        }}
      />
      <Grid
        container
        spacing={1}
        sx={{
          display: "flex",
          justifyContent: "center",
          pl: 6,
        }}
      >
        <Grid items sm={4}>
          <Box sx={{ color: "white" }}>
            <OpenSea width={"40px"} height={"40px"} />
            <Typography variant='h6' fontWeight={"bold"}>
              OpenSea
            </Typography>
            <Typography>
              The world’s first and largest digital marketplace for crypto
              collectibles and non-fungible tokens (NFTs). Buy, sell, and
              discover exclusive digital items.
            </Typography>
          </Box>
        </Grid>
        <Grid items sm={2}>
          <Box sx={{ color: "white" }}>
            <Typography fontWeight={"bold"} variant='body1' mb={3}>
              Marketplace
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant='caption' my={1}>
                All NFTs
              </Typography>
              <Typography variant='caption' my={1}>
                Arts
              </Typography>
              <Typography variant='caption' my={1}>
                Gaming
              </Typography>
              <Typography variant='caption' my={1}>
                Membership
              </Typography>
              <Typography variant='caption' my={1}>
                PFPs
              </Typography>
              <Typography variant='caption' my={1}>
                Photography
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid items sm={2}>
          <Box sx={{ color: "white" }}>
            <Typography fontWeight={"bold"} variant='body1' mb={3}>
              My Account
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant='caption' my={1}>
                Profile
              </Typography>
              <Typography variant='caption' my={1}>
                Favorites
              </Typography>
              <Typography variant='caption' my={1}>
                Watchlist
              </Typography>
              <Typography variant='caption' my={1}>
                My Collections
              </Typography>
              <Typography variant='caption' my={1}>
                Create
              </Typography>
              <Typography variant='caption' my={1}>
                OpenSea Pro
              </Typography>
              <Typography variant='caption' my={1}>
                Settings
              </Typography>
              <Typography fontWeight={"bold"} variant='body1' my={3}>
                Stats
              </Typography>
              <Typography variant='caption' my={1}>
                Rankings
              </Typography>
              <Typography variant='caption' my={1}>
                Activity
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid items sm={2}>
          <Box sx={{ color: "white" }}>
            <Typography fontWeight={"bold"} variant='body1' myy={3}>
              Resources
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant='caption' my={1}>
                Blog
              </Typography>
              <Typography variant='caption' my={1}>
                Learn
              </Typography>
              <Typography variant='caption' my={1}>
                Help Center
              </Typography>
              <Typography variant='caption' my={1}>
                User Content FAQs
              </Typography>
              <Typography variant='caption' my={1}>
                Partners
              </Typography>
              <Typography variant='caption' my={1}>
                Developers Platform{" "}
              </Typography>
              <Typography variant='caption' my={1}>
                Platform Status
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid items sm={2}>
          <Box sx={{ color: "white" }}>
            <Typography fontWeight={"bold"} variant='body1' mb={3}>
              Company
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant='caption' my={1}>
                About
              </Typography>
              <Typography variant='caption' my={1}>
                Careers
              </Typography>
              <Typography variant='caption' my={1}>
                Ventures
              </Typography>
              <Typography fontWeight={"bold"} variant='body1' my={3}>
                Learn
              </Typography>
              <Typography variant='caption' my={1}>
                What is an NFT?
              </Typography>
              <Typography variant='caption' my={1}>
                How to buy an NFT?
              </Typography>
              <Typography variant='caption' my={1}>
                What are NFT drops?
              </Typography>
              <Typography variant='caption' my={1}>
                How to sell an NFT on OpenSea
              </Typography>
              <Typography variant='caption' my={1}>
                What is crypto wallet?
              </Typography>
              <Typography variant='caption' my={1}>
                What is cryptopcurrency?
              </Typography>
              <Typography variant='caption' my={1}>
                What is a blockchain?
              </Typography>
              <Typography variant='caption' my={1}>
                What is a web3?
              </Typography>
              <Typography variant='caption' my={1}>
                How to stay protected in web3
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Divider
        sx={{
          color: "white",
          my: 3,
          px: 4,
          border: "1px solid white",
          width: "98%",
          opacity: 0.4,
        }}
      />
      <Grid container sx={{ px: 4, mb: 3 }}>
        <Grid items sm={6} sx={{ color: "white" }}>
          © 2018 - 2023 Ozone Networks, Inc
        </Grid>
        <Grid
          items
          sm={6}
          sx={{
            justifyContent: "right",
            textAlign: "right",
            color: "white",
          }}
        >
          Privacy Policy Terms of Service
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
